import { IonContent, IonModal } from '@ionic/react';
import { useState, type ComponentProps, type Dispatch, type PropsWithChildren, type SetStateAction } from 'react';

import { mergeClassNames } from '@/utils';
import { SessionTypeInDatabase } from '@/utils/getFirebaseSessionTypes';

import styles from './ChooseMeasurementModal.module.css';

import { Button } from '../Button';
import { ModalFooter } from '../ModalFooter/ModalFooter';
import { ModalHeader } from '../ModalHeader/ModalHeader';
import { SessionType, SessionTypeCard } from '../SessionTypeCard/SessionTypeCard';
interface ModalProps extends ComponentProps<typeof IonModal> {
  setShowModal: Dispatch<SetStateAction<boolean>>;
  onClose: (session: SessionTypeInDatabase | undefined) => void;
  isLoading: boolean;
  sessionTypes: SessionTypeInDatabase[];
}

export const ChooseMeasurementModal = ({
  setShowModal,
  onClose,
  isLoading,
  sessionTypes,
  ...props
}: PropsWithChildren<ModalProps>) => {
  const [selectedType, setSelectedType] = useState<SessionType | null>(null);

  const getTypeFromName = (name: string) => {
    switch (name) {
      case 'Gait Observations':
        return 'GO';
      case 'Knee Stability':
        return 'ACL';
      default:
        return 'Hamstring';
    }
  };

  return (
    <>
      <IonModal className={styles.modal} {...props} onDidDismiss={() => setShowModal(false)}>
        <ModalHeader>Choose a Session Type</ModalHeader>

        <IonContent className={mergeClassNames(styles.content, isLoading ? styles.loading : '')}>
          <div className={styles.inner}>
            {sessionTypes.map((sessionType) => (
              <SessionTypeCard
                key={sessionType.title}
                onSelect={setSelectedType}
                selected={selectedType === getTypeFromName(sessionType.title)}
                title={sessionType.title}
                type={getTypeFromName(sessionType.title)}
              />
            ))}
          </div>
        </IonContent>

        <ModalFooter>
          {' '}
          <>
            <Button onClick={() => setShowModal(false)} variant='secondary'>
              Cancel
            </Button>

            <Button
              disabled={!selectedType || isLoading}
              onClick={() => onClose(sessionTypes.find((type) => getTypeFromName(type.title) === selectedType))}
              variant='primary'>
              Start Session
            </Button>
          </>
        </ModalFooter>
      </IonModal>
    </>
  );
};
